import { useContext, useEffect } from 'react';
import { UserContext } from '../context/userContext';
import OrdersTable from './OrdersTable';

const Orders = () => {
  const { setActiveItem } = useContext(UserContext);

  useEffect(() => {
    setActiveItem('My Care Hub');
  }, []);
  
  return (
    <div className="sm:flex sm:items-center mt-6 mb-6">
      <div className="sm:flex-auto">
        <div className="sm:flex sm:items-center my-3">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-primary-blue-500">
              Orders
            </h1>
          </div>
        </div>{' '}
        <OrdersTable />
      </div>
    </div>
  );
};

export default Orders;
